import * as React from 'react';
import {
  AlertTitleProps,
  AlertTitle as MuiAlertTitle,
  useThemeProps,
} from '@mui/material';
import { useLegacyWsdStyles } from 'src/wsd/styles/context/useLegacyWsdStyles';
import { WsdAlertTitleRoot } from 'src/wsd/components/WsdAlert/WsdAlertTitleRoot';

export type { AlertTitleProps } from '@mui/material';

export const AlertTitle = React.forwardRef<HTMLElement, AlertTitleProps>(
  function AlertTitle(inProps, ref) {
    const props = useThemeProps({ props: inProps, name: 'MuiAlertTitle' });
    const isWsdAlert = useLegacyWsdStyles();

    return isWsdAlert ? (
      <WsdAlertTitleRoot ref={ref} {...props} />
    ) : (
      <MuiAlertTitle ref={ref} {...props} />
    );
  }
);

export default AlertTitle;
